import { client } from "./client";
export async function getMe() {
    return (await client.get("/api/v1/me")).data;
}
export async function changePassword(payload) {
    await client.put("/api/v1/me/password", payload);
}
export async function listMyLxc() {
    return (await client.get("/api/v1/me/lxc")).data;
}
export async function getMyLxc(vmid) {
    return (await client.get(`/api/v1/me/lxc/${vmid}`)).data;
}
export async function startMyLxc(vmid) {
    return (await client.post(`/api/v1/me/lxc/${vmid}/start`)).data;
}
export async function stopMyLxc(vmid) {
    return (await client.post(`/api/v1/me/lxc/${vmid}/stop`)).data;
}
export async function restartMyLxc(vmid) {
    return (await client.post(`/api/v1/me/lxc/${vmid}/restart`)).data;
}
export async function revealMyLxcPassword(vmid, payload) {
    return (await client.post(`/api/v1/me/lxc/${vmid}/reveal-password`, payload)).data;
}
export async function openConsole(vmid) {
    return (await client.post(`/api/v1/me/lxc/${vmid}/console`)).data;
}
export async function myTaskLog(vmid, upid, start = 0) {
    return (await client.get(`/api/v1/me/lxc/${vmid}/tasks/${encodeURIComponent(upid)}/log`, { params: { start } })).data;
}
export async function myLxcRrddata(vmid, timeframe) {
    return (await client.get(`/api/v1/me/lxc/${vmid}/rrddata`, {
        params: { timeframe },
    })).data;
}
export async function myReinstallLxc(vmid, payload) {
    return (await client.post(`/api/v1/me/lxc/${vmid}/reinstall`, payload)).data;
}
export async function listMyTemplates() {
    return (await client.get("/api/v1/me/templates")).data;
}
// ---- VM (V1.12)
export async function listMyVm() {
    return (await client.get("/api/v1/me/vm")).data;
}
export async function getMyVm(vmid) {
    return (await client.get(`/api/v1/me/vm/${vmid}`)).data;
}
export async function startMyVm(vmid) {
    return (await client.post(`/api/v1/me/vm/${vmid}/start`)).data;
}
export async function stopMyVm(vmid) {
    return (await client.post(`/api/v1/me/vm/${vmid}/stop`)).data;
}
export async function restartMyVm(vmid) {
    return (await client.post(`/api/v1/me/vm/${vmid}/restart`)).data;
}
export async function openVmConsole(vmid, protocol) {
    const url = protocol
        ? `/api/v1/me/vm/${vmid}/console?protocol=${protocol}`
        : `/api/v1/me/vm/${vmid}/console`;
    return (await client.post(url)).data;
}
export async function myVmRrddata(vmid, timeframe) {
    return (await client.get(`/api/v1/me/vm/${vmid}/rrddata`, {
        params: { timeframe },
    })).data;
}
// ---- SSH keys (V1.15)
export async function listMySshKeys() {
    return (await client.get("/api/v1/me/ssh-keys")).data;
}
export async function addMySshKey(name, public_key) {
    return (await client.post("/api/v1/me/ssh-keys", {
        name, public_key,
    })).data;
}
export async function deleteMySshKey(id) {
    await client.delete(`/api/v1/me/ssh-keys/${id}`);
}
// V1.20: server-side keypair generation
export async function generateMySshKey(name) {
    return (await client.post("/api/v1/me/ssh-keys/generate", { name })).data;
}
// ---- Snapshots (V1.17)
export async function listMyLxcSnapshots(vmid) {
    return (await client.get(`/api/v1/me/lxc/${vmid}/snapshots`)).data;
}
export async function createMyLxcSnapshot(vmid, name, description) {
    return (await client.post(`/api/v1/me/lxc/${vmid}/snapshots`, {
        name, description,
    })).data;
}
export async function deleteMyLxcSnapshot(vmid, name) {
    return (await client.delete(`/api/v1/me/lxc/${vmid}/snapshots/${name}`)).data;
}
export async function rollbackMyLxcSnapshot(vmid, name) {
    return (await client.post(`/api/v1/me/lxc/${vmid}/snapshots/${name}/rollback`)).data;
}
export async function listMyVmSnapshots(vmid) {
    return (await client.get(`/api/v1/me/vm/${vmid}/snapshots`)).data;
}
export async function createMyVmSnapshot(vmid, name, description) {
    return (await client.post(`/api/v1/me/vm/${vmid}/snapshots`, {
        name, description,
    })).data;
}
export async function deleteMyVmSnapshot(vmid, name) {
    return (await client.delete(`/api/v1/me/vm/${vmid}/snapshots/${name}`)).data;
}
export async function rollbackMyVmSnapshot(vmid, name) {
    return (await client.post(`/api/v1/me/vm/${vmid}/snapshots/${name}/rollback`)).data;
}
export async function getMyQuotas() {
    return (await client.get("/api/v1/me/quotas")).data;
}
export async function getNotifPreferences() {
    return (await client.get("/api/v1/me/notification-preferences")).data;
}
export async function updateNotifPreferences(patch) {
    return (await client.put("/api/v1/me/notification-preferences", patch)).data;
}
